import React from "react"
import PropTypes from "prop-types"
import { Button, ButtonGroup } from "react-bootstrap"
import { browserHistory } from "react-router"

import { Row, Col } from "react-bootstrap"
import FontAwesome from "react-fontawesome"
import Authenticated from "../../../../lib/Authenticated"
import SimpleCardRow from "../../../fragments/SimpleCardRow"
import CustomBreadCrumb from "../../../fragments/CustomBreadCrumb"
import { blockingFetchService } from "../../../../lib/blockingFetch"
import apiServerApi from "../../../../redux/sagas/apiServerApi"
import AlertModal from "../../../fragments/AlertModal"
import ProcessesStatus from "../../../fragments/ProcessesStatus"
import { CardType, formatCurrency } from "../../../../lib/utils"
import CreatedOnDate from "../../../fragments/CreatedOnDate"
import InvestorLink from "../../../fragments/InvestorLink"

class InvestorPaymentCard extends React.Component {

  authenticated = new Authenticated()
  isAdmin = this.authenticated.isAdmin()

  state = {
    shouldDelete: false,
    running: false,
    success: false,
    error: null,
  }

  handleDelete = () => this.setState({ 
    shouldDelete: true,
    running: false,
    success: false,
    error: null
  })

  confirmDelete = () => {

    this.setState({
      running: true,
      success: false,
      error: null,
    })

    const { investorPayment: { id: paymentId }, removeInvestorPayment, cardType } = this.props

    blockingFetchService(
      accessToken => apiServerApi.deleteInvestorPayment(accessToken, paymentId),
      _ => {

        this.setState({ success: true })
        setTimeout(() => {

          this.closeDeleteForm()
          removeInvestorPayment(paymentId)

          if (cardType === CardType.LARGE) {
            browserHistory.push('/financiers/investors/payments')
          }
        }, 800)
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  closeDeleteForm = () => this.setState({ shouldDelete: false })

  renderDeletionConfirmContent = () => {

    const { running, success, error } = this.state,
    { investorPayment: { id } } = this.props

    return (
      <div>
        <h3>Are you sure you want to delete &#171; { id } &#187;?</h3>
        <ProcessesStatus error={ error } running={ running } success={ success } />
      </div>
    )
  }

  renderBtnGroup = (id, isLarge) => (
    <ButtonGroup justified>

      <Button href="#" bsStyle="success" disabled={ !this.isAdmin }
        onClick={() => browserHistory.push(`/financiers/investors/payments/${id}/update`)}>
        <FontAwesome name='pencil' /> Update
      </Button>

      <Button href="#" bsStyle="warning" disabled={ !this.isAdmin }
        onClick={ this.handleDelete } title={ 'Delete' }>
        <FontAwesome name='trash-o' /> Delete
      </Button>

      { isLarge &&
      <Button href="#"
        onClick={() => browserHistory.push('/financiers/investors/payments/new')}>
        <FontAwesome name='plus-circle' /> New Payment
      </Button>}
    </ButtonGroup>
  )

  showItem = () => {

    const { investorPayment, cardType } = this.props,

    { id, investor: { id: investorId, name }, currencyCode, amount,
      paymentType, createdOn } = investorPayment,

    isLarge = cardType === CardType.LARGE

    return (
      <div className='detail-content'>

        { this.renderBtnGroup(id, isLarge) }

        <h2 className='blue mt-20'>#{ id }</h2>

        <SimpleCardRow name='Investor' value={ <InvestorLink id={ investorId } name={ name } /> } />

        <SimpleCardRow name='Currency' value={ currencyCode } />

        <SimpleCardRow name='Amount' value={ formatCurrency(amount) } title='Payment Amount' />

        <SimpleCardRow name='Payment Mode' value={ paymentType } />

        <hr />
        <CreatedOnDate createdOn={ createdOn } />
      </div>
    )
  }

  renderLargeCard = () => {

    const breadCrumbData = [
      { url: '/financiers', title: 'Financiers' },
      { url: '/financiers/investors', title: 'Investors' },
      { url: '/financiers/investors/payments', title: 'Payments' }
    ],

    { investorPayment: { id } } = this.props

    return (
      <div>
        <CustomBreadCrumb activeText={ id } data={ breadCrumbData } />
        <Row>
          <Col md={4} className="align-center">
            <FontAwesome name="fire" size="3x" className="detail-icon" />
          </Col>

          <Col md={8}>
            { this.showItem() }
          </Col>
        </Row>
      </div>
    )
  }

  render() {
    const { cardType } = this.props,
    { shouldDelete, running } = this.state

    return (
      <div>

        { cardType === CardType.SMALL ? this.showItem() : this.renderLargeCard() }

        <AlertModal
          show={ shouldDelete }
          title="Confirm deletion"
          body={ this.renderDeletionConfirmContent() }
          bsStyle="danger"
          close={ this.closeDeleteForm }
          confirm={ this.confirmDelete }
          proceedText="Delete"
          disabled={ running }
        />
      </div>
    )
  }
}

InvestorPaymentCard.propTypes = {
  investorPayment: PropTypes.object.isRequired,
  cardType: PropTypes.string.isRequired,
}

export default InvestorPaymentCard



// WEBPACK FOOTER //
// ./src/components/Financiers/Investors/Payments/Card.js